module.exports = __webpack_public_path__ + "img/circle-01.132786f9.svg";